import React from 'react';
import {useTheme} from 'styled-components/native';

import {BaratinhaItemDTO} from '../../../../dtos/PaymentItemDTO';

import {
  Container,
  Infos,
  InfoContainer,
  Title,
  TransactionDate,
  Values,
  Value,
  Button,
} from './styles';
import {Icon} from '../../../Interface/Typographies/Icon';
import {format} from 'date-fns';

interface Props {
  data: BaratinhaItemDTO;
}

export function BaratinhaItem({data}: Props) {
  const theme = useTheme();

  const date = format(new Date(data.dataCompra), 'dd/MM/yy');
  const time = format(new Date(data.dataCompra), 'HH:mm');

  return (
    <Container>
      <Button>
        <Infos>
          <Icon
            name={data.tipo_transacao === 'C' ? 'arrow-up' : 'arrow-down'}
            iconColor={
              data.tipo_transacao === 'C'
                ? theme.colors.primary
                : theme.colors.red
            }
            color={
              data.tipo_transacao === 'C'
                ? theme.colors.primary_light
                : theme.colors.red_light
            }
          />
          <InfoContainer>
            <Title>{data.tipo_transacao === 'C' ? 'Entrada' : 'Saída'}</Title>
            <TransactionDate>
              {date} às {time}
            </TransactionDate>
          </InfoContainer>
        </Infos>
        <Values>
          <Value
            style={{
              color:
                data.tipo_transacao === 'C'
                  ? theme.colors.primary
                  : theme.colors.red,
            }}>
            {data.qtd_pontos
              ? data.tipo_transacao === 'C'
                ? '+' + data.qtd_pontos + ' btz'
                : '-' + data.qtd_pontos + ' btz'
              : 'Não definido'}
          </Value>
        </Values>
      </Button>
    </Container>
  );
}
